import React from 'react';

/** The 12-column hairline grid printed over the whole page. */
export default function Rails() {
  return <div className="rails" aria-hidden="true" />;
}
